import React from 'react';
import ReactDOM from 'react-dom';
import { FaTimes } from 'react-icons/fa';
import styles from './SkuSelectionModal.module.css';

const DownloadIcon = () => (
    <svg width="20" height="25" viewBox="0 0 20 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 22.2422H19.77V24.7131H0V22.2422Z" fill="#737373"/>
    <path d="M19.4117 10.7622L17.6573 9.0078L11.1216 15.556V0H8.64945V15.556L2.11374 9.0078L0.359375 10.7622L9.88537 20.2756L19.4117 10.7622Z" fill="#737373"/>
    </svg>
);

const PushIcon = () => (
    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.99946 16.8822C10.586 16.8822 11.0607 16.4067 11.0607 15.8209V3.61062L15.9666 8.51723C16.1739 8.72453 16.4456 8.82783 16.7173 8.82783C16.989 8.82783 17.2607 8.72453 17.468 8.51723C17.8826 8.10262 17.8826 7.43119 17.468 7.01659L10.7501 0.298748C10.3518 -0.0995826 9.64712 -0.0995826 9.2495 0.298748L2.53166 7.01659C2.11705 7.43119 2.11705 8.10262 2.53166 8.51723C2.94626 8.93183 3.61769 8.93183 4.03229 8.51723L8.93819 3.61062V15.8209C8.93819 16.4067 9.41293 16.8822 9.99946 16.8822Z" fill="#737373"/>
    <path d="M1.06127 13.4629C0.474742 13.4629 0 13.9383 0 14.5242V19.4435C0 20.0293 0.474742 20.5048 1.06127 20.5048H18.9387C19.5253 20.5048 20 20.0293 20 19.4435V14.5242C20 13.9383 19.5253 13.4629 18.9387 13.4629C18.3522 13.4629 17.8775 13.9383 17.8775 14.5242V18.3822H2.12254V14.5242C2.12254 13.9383 1.6478 13.4629 1.06127 13.4629Z" fill="#737373"/>
    </svg>
);

const Backdrop = (props) => (
    <div className={styles.backdrop} onClick={props.onClose} />
);

const ModalOverlay = (props) => {
    const { skuList, selectedSkus, onSkuToggle, onSelectAll, onConfirm, title, buttonText, iconType, isConfirming } = props;
    const selectedCount = selectedSkus.length;
    const totalCount = skuList.length;
    const selectAll = totalCount > 0 && selectedCount === totalCount;

    const handleSelectAll = () => {
        if (selectAll) {
            onSelectAll([]);
        } else {
            onSelectAll(skuList.map((item) => item.sku));
        }
    };

    const IconComponent = iconType === 'push' ? PushIcon : DownloadIcon;

    return (
        <div className={styles.modal}>
            <header className={styles.header}>
                <div className={styles.headerTitleRow}>
                    <IconComponent />
                    <h2>{title}</h2>
                </div>
                <button onClick={props.onClose} className={styles.closeButton} aria-label="Close Modal">
                    <FaTimes />
                </button>
            </header>

            <div className={styles.selectionSummary}>
                <div className={styles.selectionSummaryRow}>
                    <span className={styles.selectedCount}>
                        {selectedCount}/{totalCount} Selected
                    </span>
                    <label className={styles.selectAllLabel}>
                        <input
                            type="checkbox"
                            checked={selectAll}
                            onChange={handleSelectAll}
                        />
                        <span>Select All</span>
                    </label>
                </div>
            </div>

            <div className={styles.content}>
                <div className={styles.productsGrid}>
                    {skuList.map((item) => {
                        const isSelected = selectedSkus.includes(item.sku);
                        return (
                            <div key={item.sku} className={styles.productCardWrapper}>
                                        <input
                                            type="checkbox"
                                            checked={isSelected}
                                            onChange={() => onSkuToggle(item.sku)}
                                            className={styles.productCheckbox}
                                        />
                                        <div
                                            className={styles.productCard}
                                            onClick={() => onSkuToggle(item.sku)}
                                        >
                                            <div className={styles.productCardInner}>
                                                <div className={styles.productImage}>
                                                    {item.thumbnail ? (
                                                        <img
                                                            src={item.thumbnail}
                                                            alt={item.title || item.sku}
                                                            onError={(e) => {
                                                                e.target.style.display = 'none';
                                                            }}
                                                        />
                                                    ) : (
                                                        <div className={styles.productImagePlaceholder} />
                                                    )}
                                                </div>
                                                <div className={styles.productInfo}>
                                                    <div className={styles.productInfoInner}>
                                                        <div className={styles.productName}>
                                                            {(item.title || `Product ${item.sku}`).length > 45
                                                                ? `${(item.title || item.sku).slice(0, 45)}...`
                                                                : (item.title || `Product ${item.sku}`)}
                                                        </div>
                                                        <div className={styles.skuTag}>
                                                            <span>SKU ID : {item.sku}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                );
                    })}
                </div>
            </div>

            <footer className={styles.actions}>
                <button
                    onClick={onConfirm}
                    disabled={selectedCount === 0 || isConfirming}
                    className={`${styles.button} ${styles.buttonPrimary} ${(selectedCount === 0 || isConfirming) ? styles.disabled : ''}`}
                >
                    {isConfirming ? 'Processing...' : buttonText}
                </button>
            </footer>
        </div>
    );
};

const SkuSelectionModal = (props) => {
    if (typeof window === 'undefined') {
        return null;
    }

    const portalElement = document.getElementById('modal-root');
    if (!portalElement) {
        return null;
    }

    if (!props.show) {
        return null;
    }

    return (
        <React.Fragment>
            {ReactDOM.createPortal(
                <Backdrop onClose={props.onClose} />,
                portalElement
            )}
            {ReactDOM.createPortal(
                <ModalOverlay
                    skuList={props.skuList || []}
                    selectedSkus={props.selectedSkus || []}
                    onSkuToggle={props.onSkuToggle}
                    onSelectAll={props.onSelectAll}
                    onConfirm={props.onConfirm}
                    onClose={props.onClose}
                    title={props.title || 'Download Content'}
                    buttonText={props.buttonText || 'Download Content'}
                    iconType={props.iconType || 'download'}
                    isConfirming={props.isConfirming || false}
                />,
                portalElement
            )}
        </React.Fragment>
    );
};

export default SkuSelectionModal;
